import { makeAutoObservable } from "mobx";
import userStore from "./userStore";
import profileStore from "./profileStore";

class SessionStore {
  _currentUser = null;
  careerClimbCompletionData = null;
  clusterCompletionData = null;
  activeErrors = [];
  newlyCompletedAwards = [];
  clusterContentIndex = {};
  activeNextStep = null;
  recentEvents = [];

  get currentUser() {
    console.error(
      "🚨🚨🚨 ERROR: Don't get currentUser from sessionStore! This won't work right. 🚨🚨🚨",
    );
    return this._currentUser;
  }

  set currentUser(value) {
    this._currentUser = value;
  }

  constructor() {
    makeAutoObservable(this);
  }

  reportError(errorText, errorObject, fatal = true) {
    this.activeErrors.push({ errorText, errorObject, fatal });
  }

  setActiveNextStep(nextStep) {
    this.activeNextStep = nextStep;
  }

  clearActiveNextStep() {
    this.activeNextStep = null;
  }

  setCareerClimbCompletionData(data) {
    this.careerClimbCompletionData = data;
  }

  removeCareerClimbCompletionData() {
    this.careerClimbCompletionData = null;
  }

  setClusterCompletionData(data) {
    this.clusterCompletionData = data;
  }

  removeClusterCompletionData() {
    this.clusterCompletionData = null;
  }

  updateReceivedSurvey() {
    this.currentUser.receivedSurvey = true;
  }

  setValuesScoresForLadder(ladderId, valuesScores) {
    const oldScores =
      this.currentUser.values.filter((score) => score.ladderId !== ladderId) ||
      [];
    this.currentUser.values = [...oldScores, valuesScores];
    this.setCurrentUser(this.currentUser);
  }

  setCurrentUser(user) {
    this.currentUser = user;
    userStore.setUser(user); // Sync back to userStore
  }

  removeCurrentUser() {
    this.currentUser = null;
    userStore.removeUser();
    profileStore.clearProfile();
  }

  addNewlyCompletedAward(award) {
    this.newlyCompletedAwards.push(award);
  }

  removeFirstCompletedAward() {
    this.newlyCompletedAwards.shift();
  }

  clearNewlyCompletedAwards() {
    this.newlyCompletedAwards = [];
  }

  // Cluster content index management
  getClusterContentIndex(clusterId) {
    return this.clusterContentIndex[clusterId] || 0;
  }

  setClusterContentIndex(clusterId, contentIndex) {
    this.clusterContentIndex[clusterId] = contentIndex;
  }

  // Recent events management
  addRecentEvent(event) {
    if (this.recentEvents.length > 50) {
      this.recentEvents.shift();
    }
    this.recentEvents.push(event);
  }

  getRecentEvents() {
    return [...this.recentEvents]; // Return a copy to avoid mutations
  }

  clearRecentEvents() {
    this.recentEvents = [];
  }
}

const sessionStore = new SessionStore();
export default sessionStore;
